import React from "react";
import style from "./Registration.module.scss";
import { en as locale } from "../../helpers/translationTexts";
import DropDownArrowIcon from "../../svg/DropDownArrowIcon";
import * as RegistrationProps from "../../types/registration";
import styles from "./Registration.module.scss";
import useTranslation from "../../helpers/translationTexts/useTranslation";

const RegistrationContainer: React.FC<RegistrationProps.Props> = ({ children }) => {
  return <div className={style.registrationContainer}>{children}</div>;
};

const Title: React.FC<RegistrationProps.Props> = ({ children }) => {
  return <h2 className={style.title}> {children} </h2>;
};

const InputNickName: React.FC<RegistrationProps.InputNickNameProps> = ({ nickName, handleNicknameChange }) => {
  return (
    <div className={styles.inputWrapper}>
      <label className={styles.label} htmlFor="nickName">
        {useTranslation("nickName")}
      </label>
      <input
        className={styles.input}
        type="text"
        pattern="[a-zA-Z0-9]{4,20}"
        name="nickName"
        id="nickName"
        placeholder={`${locale.createYourNickName}`}
        value={nickName}
        onChange={handleNicknameChange}
      />
    </div>
  );
};

const SelectedCountryInput: React.FC<RegistrationProps.SelectedCountryInputProps> = ({ selectedCountry, onClick }) => (
  <div className={styles.inputWrapper} onClick={onClick}>
    <p className={styles.label}> {useTranslation("country")}</p>
    <div className={styles.input + " " + styles.inputCounty}>
      <img className={styles.inputFlag} src={selectedCountry.flags.svg} alt={selectedCountry.flags.alt} />
      {selectedCountry.name}
      <DropDownArrowIcon className={styles.inputArrow} />
    </div>
  </div>
);

const FilterCountryInput: React.FC<RegistrationProps.FilterCountryInput> = ({ value, onChange }) => (
  <div className={styles.inputWrapper}>
    <input
      className={styles.input}
      type="text"
      pattern="[a-zA-Z]{4,20}"
      name="filterCountry"
      placeholder={`${locale.country}`}
      value={value}
      onChange={(e) => onChange(e)}
    />
  </div>
);

const SelectCountryDropdown: React.FC<RegistrationProps.SelectCountryDropdownProps> = ({
  countries,
  handleCountryChange,
}) => {
  return (
    <ul className={styles.list}>
      {countries.map((country) => (
        <li
          className={style.listItem}
          key={country.code}
          onClick={() => {
            handleCountryChange(country);
          }}
        >
          <img className={style.listImg} src={country.flags.svg} alt={country.flags.alt} />
          {country.name}
        </li>
      ))}
    </ul>
  );
};

const SignUpButton: React.FC<RegistrationProps.ButtonProps> = ({ children, onClick }) => {
  return (
    <button type="button" className={style.button} onClick={() => onClick()}>
      {children}
    </button>
  );
};

const GoBackButton: React.FC<RegistrationProps.ButtonProps> = ({ children, onClick }) => {
  return (
    <button type="button" className={`${style.button} ${style.goBackButton}`} onClick={() => onClick()}>
      {children}
    </button>
  );
};

const Loader: React.FC = () => {
  return <div className={style.loaderHourGlass} />;
};

export {
  RegistrationContainer,
  Title,
  SignUpButton,
  InputNickName,
  SelectedCountryInput,
  SelectCountryDropdown,
  FilterCountryInput,
  Loader,
  GoBackButton,
};
